<template>
  <title-block :title="`Special Collection Archives`" color-theme="primary-color" v-if="items.length">
    <div class="container">
      <div class="row">
        <div v-for="(item, index) in items" class="col-12">
          <div class="title">{{item.title}}</div>
          <div>{{item.text}}</div>
        </div>
      </div>
    </div>
  </title-block>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'special-collection-archives',
    components: {
      TitleBlock
    },
    mixins: [ UtilityMixin ],
    data () {
      return {
        items: []
      }
    },
    created () {
      // ToDo: replace mock.json with data from services (collections list)
      this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
        this.items = response.body.specialCollectionArchives
      }, function () {
      })
    }
  }
</script>

<style lang="scss" scoped>
  .row > div {
    margin-top: 28px;
    padding-bottom: 24px;
    font-family: OpenSans;
    font-size: 14px;
    line-height: 1.21;
    text-align: left;
    color: $accent-color-3;
    &:not(:last-child) {
      border-bottom: 1px solid rgba($black, 0.1);
    }
    .title {
      font-family: Merriweather;
      font-size: 20px;
      font-weight: 300;
      line-height: 1.25;
      text-align: left;
      color: #ed643f;
      margin-bottom: 19px;
    }
  }
</style>



// WEBPACK FOOTER //
// SpecialCollectionArchivesComponent.vue?51338dcc